module.exports = __webpack_public_path__ + "static/media/cellphone.1e602cdd.jpg";